import api from "../http";

export default class MainKeeperAPI {
    static async getAll(isPhysical) {
        if (isPhysical != undefined) return api.get('/mainkeeper?isPhysical=' + isPhysical);
        return api.get('/mainkeeper');
    }

    static async clone(cloneAll, list, fromPhysical) {
        return api.post("/mainkeeper/clone", { cloneAll, list, fromPhysical });
    }

    static async create(item) {
        return api.post('/mainkeeper/', item);
    }

    static async update(item) {
        return api.post('/mainkeeper/edit', item);
    }

    static async remove(id) {
        return api.get('/mainkeeper/remove?id=' + id);
    }
}
